export enum NewsletterTitleIconType {
  Submit = 'Submit',
  Subscribe = 'Subscribe',
  Error = 'Error',
}

export interface TitleIconProps {
  icon?: NewsletterTitleIconType;
}
